import { network } from 'services/network';

import { QueryParams, QueryResponse } from 'api/queries/getSpiTrend.query';

export const ENDPOINT = 'api/bo/getSPITrend';

export const getSpiTrend = (params: QueryParams): Promise<QueryResponse> => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
